import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { GlobalContext } from '../lib/GlobalVar';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import AssistenteVoz from './AssistenteVoz';
import VoltarAoTopo from './VoltarAoTopo';
import VerComoBanner from './VerComoBanner';
import { AbasPersonalizadasProvider, BarraAbas } from '../personalizados/AbasPersonalizadas';

// Em dispositivos de toque o hover-expand fica desligado (evita o drawer/scrim
// disparar por um mouseenter emulado no tap).
const semHover = () => {
    try { return window.matchMedia('(hover: none)').matches; } catch (_) { return false; }
};

export default function HomePage() {
    const { palette, mode, user } = useContext(GlobalContext);
    const userId = (user && (user.id || user.email)) || 'anon';
    const [collapsed, setCollapsed] = useState(true);
    const [hovered, setHovered] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const root = document.documentElement;
        root.setAttribute('data-palette', palette || 'atelier');
        root.setAttribute('data-mode', mode === 'dark' ? 'dark' : 'light');
        root.setAttribute('data-type', 'serif');
        root.setAttribute('data-density', 'balanced');
        root.setAttribute('data-card', 'thin');
    }, [palette, mode]);

    // Mobile: fecha o drawer ao navegar entre paginas.
    useEffect(() => {
        if (typeof window !== 'undefined' && window.innerWidth <= 860) {
            setCollapsed(true);
            setHovered(false);
        }
    }, [location.pathname]);

    const expanded = !collapsed || hovered;
    const fecharDrawer = () => { setCollapsed(true); setHovered(false); };
    const aoHover = (v) => { if (!semHover()) setHovered(v); };

    return (
        <div className="app-shell" data-sidebar={expanded ? 'expanded' : 'collapsed'}>
            <Sidebar collapsed={collapsed} hovered={hovered} onHover={aoHover}/>
            <div className="drawer-scrim" onClick={fecharDrawer} aria-hidden="true"/>
            <main className="main">
                <VerComoBanner/>
                <Topbar onToggleSidebar={() => setCollapsed(v => !v)}/>
                <AbasPersonalizadasProvider key={userId} userId={userId}>
                    <BarraAbas/>
                    <Outlet/>
                </AbasPersonalizadasProvider>
            </main>
            <VoltarAoTopo/>
            <AssistenteVoz/>
        </div>
    );
}
